export const multipaymentManager = {
  init: () => window.Multipayment.init(process.env.REACT_APP_SHOP_ID),
  getToken: (params, callback) => window.Multipayment.getToken(params, callback)
};

export default multipaymentManager;



// WEBPACK FOOTER //
// ./src/util/multipayment.js